<template>
  <div class="blocks-accordion">
    <h3 class="speaker-headline">Mine foredrag</h3>
    <div class="accordion-item" v-for="(item, index) in faq" :key="index">
      <div class="accordion-header" @click="toggle(index)">
        <h4>{{ item.title }}</h4>
        <span class="icon" :class="{ open: isOpen(index) }">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              fill="currentColor"
              d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
            />
          </svg>
        </span>
      </div>
      <div class="accordion-content" :class="{ open: isOpen(index) }" v-html="item.text"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openIndex: null
    };
  },
  props: [
    'faq'
  ],
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    isOpen(index) {
      return this.openIndex === index;
    }
  }
};
</script>

<style scoped lang="scss">
.blocks-accordion {
  .accordion-item {
    border-bottom: 1px solid #2f4286;

    .accordion-header {
      padding: 15px 0;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h4 {
        font-size: 22px;
        line-height: 48px;
        font-weight: bold;
        margin-bottom: 0;
      }

      .icon {
        transition: transform 0.3s ease;
        color: #2f4286;
        display: flex;
        align-items: center;


        &.open {
          transform: scaleY(-1);
        }

        svg {
          width: 25px;
          height: 19px;
          min-width: 25px;
          fill: #2f4286;
        }
      }
    }

    .accordion-content {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease, padding 0.3s ease;
      font-size: 16px;
      line-height: 24px;
      color: #2f4286;

      &.open {
        max-height: 999px;
        padding: 10px 0;
      }
    }
  }
}
</style>
